
export const API_BASE_URL_IDENTITY_PROVIDER_SERVICE = process.env.REACT_APP_API_BASE_URL_IDENTITY_PROVIDER_SERVICE;
export const API_BASE_URL_TRADER_SERVICE = process.env.REACT_APP_API_BASE_URL_TRADER_SERVICE;
export const API_BASE_URL_IFOOD_SERVICE = process.env.REACT_APP_API_BASE_URL_IFOOD_SERVICE;
export const API_BASE_URL_PRODUCT_SERVICE = process.env.REACT_APP_API_BASE_URL_PRODUCT_SERVICE;

// url for local development
// export const  API_BASE_URL_IDENTITY_PROVIDER_SERVICE = 'http://localhost:8009/identity-service';
// export const  API_BASE_URL_TRADER_SERVICE = 'http://localhost:8100/trader-service';
// export const  API_BASE_URL_IFOOD_SERVICE = 'http://localhost:8101/ifood-service';
// export const  API_BASE_URL_PRODUCT_SERVICE = 'http://localhost:8102/product-service';

// url for DEV
// export const API_BASE_URL_IDENTITY_PROVIDER_SERVICE = 'https://dev.itdt.food.ikeadt.com/identity-service';
// export const API_BASE_URL_TRADER_SERVICE = 'https://dev.itdt.food.ikeadt.com/trader-service';
// export const API_BASE_URL_IFOOD_SERVICE = 'https://dev.itdt.food.ikeadt.com/ifood-service';
// export const API_BASE_URL_PRODUCT_SERVICE = 'https://dev.itdt.food.ikeadt.com/product-service';

// url for Pre-production
// export const API_BASE_URL_IDENTITY_PROVIDER_SERVICE = 'https://ppe.itdt.food.ikeadt.com/identity-service';
// export const API_BASE_URL_TRADER_SERVICE = 'https://ppe.itdt.food.ikeadt.com/trader-service';
// export const API_BASE_URL_IFOOD_SERVICE = 'https://ppe.itdt.food.ikeadt.com/ifood-service';
// export const API_BASE_URL_PRODUCT_SERVICE = 'https://ppe.itdt.food.ikeadt.com/product-service';

// url for production
//export const API_BASE_URL_IDENTITY_PROVIDER_SERVICE = 'https://itdt.food.ikea.net/identity-service';
//export const API_BASE_URL_TRADER_SERVICE = 'https://itdt.food.ikea.net/trader-service';
//export const API_BASE_URL_IFOOD_SERVICE = 'https://itdt.food.ikea.net/ifood-service';
//export const API_BASE_URL_PRODUCT_SERVICE = 'https://itdt.food.ikea.net/product-service';
